import { LanguageLevel } from '@borg/types';

class LanguageLevelsRepository extends Repository<LanguageLevel> {
  getMany() {
    return this._getMany({ url: `/apps/language-levels` });
  }
}

export const languageLevelsRepository = new LanguageLevelsRepository();
